export default {
  entidade: {
    relationships: {
      files: [],
    },
  },
};
